import { getLastLocation } from '../../components/routing/LastLocationProvider'

//
// Closes the connect-a-screen modal.
//
// Three ways in, so three ways out. Opened over a page (hash) or navigated to
// from inside the app, going back returns the teacher where they were - the
// same thing hideLiveViewModal does. Landing straight on /auth-player from a QR
// code leaves no history to go back to, so that case goes to the library
// instead of nowhere.
//
export function hideAuthPlayerModal(history) {
  if (getLastLocation()) {
    window.history.back(1)
    return
  }
  if (window.location.hash) {
    window.location.hash = ''
    return
  }
  history.push('/')
}
